/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TutorialService {
    /**
     * Complete a tutorial step
     * @returns void
     * @throws ApiError
     */
    public static completeTutorialStep({
        step,
    }: {
        step: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tutorial/steps/{step}/complete',
            path: {
                'step': step,
            },
            errors: {
                403: `Not authorized (missing API token)`,
            },
        });
    }
    /**
     * Get the current tutorial step
     * @returns boolean Tutorial step completion status retrieved
     * @throws ApiError
     */
    public static getTutorialStepCompleted({
        step,
    }: {
        step: string,
    }): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/tutorial/steps/{step}/completed',
            path: {
                'step': step,
            },
            errors: {
                403: `Not authorized (missing API token)`,
            },
        });
    }
}
